import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";

function yoyGrowth(table, month, currentMrr) {
  const [year, mon] = month.split("-").map(Number);
  const priorYear = `${year - 1}-${String(mon).padStart(2, "0")}`;
  const priorRow = table.find((r) => r.month === priorYear);
  if (!priorRow || priorRow.total_mrr === 0) return null;
  return ((currentMrr - priorRow.total_mrr) / priorRow.total_mrr) * 100;
}

export default function ReportTable({ report, formatCurrency, formatMonthLabel }) {
  return (
    <div className="overflow-hidden rounded-md border border-[#cccccc] bg-white" data-testid="mrr-table-wrapper">
      <Table>
        <TableHeader className="bg-[#f5f5f5]">
          <TableRow>
            <TableHead data-testid="mrr-table-month-header">Month</TableHead>
            <TableHead data-testid="mrr-table-total-header">Total MRR</TableHead>
            <TableHead data-testid="mrr-table-yoy-header" className="text-[#4a5b68]">YoY</TableHead>
            {report.products.map((product) => (
              <TableHead key={product} data-testid={`mrr-table-header-${product}`}>
                {product}
              </TableHead>
            ))}
          </TableRow>
        </TableHeader>
        <TableBody>
          {report.table.map((row) => {
            const yoy = yoyGrowth(report.table, row.month, row.total_mrr);
            return (
              <TableRow key={row.month} data-testid={`mrr-table-row-${row.month}`}>
                <TableCell className="font-medium text-[#323c44]" data-testid={`mrr-table-month-${row.month}`}>
                  {formatMonthLabel(row.month)}
                </TableCell>
                <TableCell className="font-mono text-[#323c44]" data-testid={`mrr-table-total-${row.month}`}>
                  {formatCurrency(row.total_mrr)}
                </TableCell>
                <TableCell className="font-mono text-xs" data-testid={`mrr-table-yoy-${row.month}`}>
                  {yoy === null ? (
                    <span className="text-[#7d8b96]">—</span>
                  ) : (
                    <span className={yoy >= 0 ? "text-[#3facc6]" : "text-[#f2545b]"}>
                      {yoy >= 0 ? "+" : ""}{yoy.toFixed(1)}%
                    </span>
                  )}
                </TableCell>
                {report.products.map((product, index) => (
                  <TableCell key={`${row.month}-${product}`} className="font-mono text-[#4a5b68]" data-testid={`mrr-table-value-${row.month}-${product}`}>
                    <span className="mr-2 inline-block h-2.5 w-2.5 rounded-full" style={{ backgroundColor: ["#50e3c2", "#3facc6", "#4a5b68", "#7d8b96", "#cccccc", "#a7f0df"][index % 6] }} />
                    {formatCurrency(row.product_values[product] || 0)}
                  </TableCell>
                ))}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
}
